export default {
    // icon1: "/static/image/index-icon-1.jpg",
    // icon2: "/static/image/index-icon-2.jpg",
    // icon3: "/static/image/index-icon-3.jpg",
    icon1: "/static/image/home_safe_icon.png",
    icon2: "/static/image/home_Lock_icon.png",
    icon3: "/static/image/home_consumer_icon.png",
    langzh: "/static/image/zh_flag.png",
    langen: "/static/image/en_flag.png",
    langtw:  "/static/image/tw_flag.png",
    langjp: "/static/image/jp_flag.png",
    langxby: "/static/image/xby_flag.png",
    langty: "/static/image/ty_flag.png",
    langhy: "/static/image/hy_flag.png",
    langdy: "/static/image/dy_flag.png",
    langfy: "/static/image/fy_flag.png",
    langyn: "/static/image/yn_flag.png",
    zhsz: "/static/image/icon-zhsz.png",
    jtrz: "/static/image/icon-jyrz.png",
    sfrz: "/static/image/icon-sfrz.png",
    iconchecked: "/static/image/icon-checked.png",
    iconcheck: "/static/image/icon-check.png",
    // iconbg: '/static/image/index-bg.png',
     iconbg: '/static/image/home_phone.png',
    indexphone: '/static/image/index-phone.png',
    icon1_01: "/static/image/pic1.png",
    icon1_02: "/static/image/pic2.png",
    icon1_03: "/static/image/pic3.png",
    icon1_04: "/static/image/pic4.png",
    banner01: "/static/image/pict1.png",
    banner02: "/static/image/pict2.png",
    banner03: "/static/image/pict3.png",
}


// WEBPACK FOOTER //
// ./src/utils/pic.js